import basicScroll from 'basicscroll'
import Popup from '../components/team-popup.svelte'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {
		scrollReveals()
		parallax()
	},
	finalize() {
		new Popup({
			target: document.body,
		})
	},
}

function scrollReveals() {
	let $homeAboutIntro = $('.home-about-intro')
	if ($homeAboutIntro.length) {
		let intro_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.home-about-intro',
				start: 'top center+=300', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		intro_tl.fromTo(
			'.home-about-intro .home-about-intro-content',
			{
				opacity: 0,
				x: -40,
			},
			{
				delay: 0.1,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		),
			intro_tl.fromTo(
				'.home-about-intro .home-about-intro-img-wrap',
				{
					opacity: 0,
					x: 40,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					x: 0,
				}
			)
		if (!window.matchMedia('(max-width: 768px)').matches) {
			intro_tl.fromTo(
				'.home-about-intro .home-about-green-box-1',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			intro_tl.fromTo(
				'.home-about-intro .home-about-green-box-2',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			intro_tl.fromTo(
				'.home-about-intro .home-about-green-box-4',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)

			intro_tl.fromTo(
				'.home-about-intro .home-about-green-box-3',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
		} else {
			intro_tl.fromTo(
				'.home-about-intro .home-about-green-box-1',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			intro_tl.fromTo(
				'.home-about-intro .home-about-green-box-3',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			intro_tl.fromTo(
				'.home-about-intro .home-about-green-box-4',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			intro_tl.fromTo(
				'.home-about-intro .home-about-green-box-2',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
		}
	}

	let $teamSection = $('.team-section')
	if ($teamSection.length) {
		let team_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.team-section',
				start: 'top center', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		team_tl.fromTo(
			'.team-section > h2',
			{
				opacity: 0,
				x: -40,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		team_tl.fromTo(
			'.team-section > h2 .bg-word',
			{
				opacity: 0,
				x: 40,
			},
			{
				delay: 0,
				duration: 0.3,
				opacity: 0.29,
				x: 0,
			}
		)
		let $teamItems = $('.team-item')
		if ($teamItems.length) {
			$teamItems.each(function (i) {
				team_tl.fromTo(
					$(this)[0],
					{
						opacity: 0,
						y: -20,
					},
					{
						// delay: i * 0.001,
						duration: 0.25,
						opacity: 1,
						y: 0,
						stagger: 0.1,
						ease: 'power1.out',
					}
				)
			})
		}
	}

	let $careers = $('#careers')
	if ($careers.length) {
		let car_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '#careers',
				start: 'top center+=300', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		car_tl.fromTo(
			'#careers > h2',
			{
				opacity: 0,
				x: 40,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		car_tl.fromTo(
			'#careers > h2 .bg-word',
			{
				opacity: 0,
				x: -40,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 0.29,
				x: 0,
			}
		)
		car_tl.fromTo(
			'#careers > p',
			{
				opacity: 0,
				y: 40,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 1,
				y: 0,
			}
		)
		car_tl.fromTo(
			'#careers > .link-wrap',
			{
				opacity: 0,
				y: 40,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 1,
				y: 0,
			}
		)
	}
}

function parallax() {
	let scrollAnimations = []

	let $aboutIntro = $('.home-about-intro')
	if ($aboutIntro.length) {
		scrollAnimations.push(
			basicScroll.create({
				elem: $('.main-content-wrap .compass-svg')[0],
				from: 'top-bottom',
				to: 'bottom-top',
				direct: true,
				props: {
					'--aty':
						innerWidth > 600
							? {
									from: '-49%',
									to: '-59%',
							  }
							: {
									from: '-49%',
									to: '-59%',
							  },
				},
			})
		)
	}

	let $teamSection = $('.team-section .compass-svg')
	if ($teamSection.length) {
		scrollAnimations.push(
			basicScroll.create({
				elem: $('.team-section .compass-svg')[0],
				from: 'top-bottom',
				to: 'bottom-top',
				direct: true,
				props: {
					'--ar':
						innerWidth > 600
							? {
									from: '0deg',
									to: '45deg',
							  }
							: {
									from: '0deg',
									to: '45deg',
							  },
				},
			})
		)
	}

	if (scrollAnimations.length) {
		scrollAnimations.forEach((instance) => instance.start())
	}
}
